import { render, staticRenderFns } from "./SysEdit.vue?vue&type=template&id=3a377c35&"
import script from "./SysEdit.vue?vue&type=script&lang=js&"
export * from "./SysEdit.vue?vue&type=script&lang=js&"
import style0 from "./SysEdit.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a377c35')) {
      api.createRecord('3a377c35', component.options)
    } else {
      api.reload('3a377c35', component.options)
    }
    module.hot.accept("./SysEdit.vue?vue&type=template&id=3a377c35&", function () {
      api.rerender('3a377c35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/SubSys/SysEdit.vue"
export default component.exports